(()=>{
function setupHatxaPopup(){
  const popup=document.querySelector('[data-hatxa-popup]');
  if(!popup||popup.dataset.hatxaPopupReady)return;
  popup.dataset.hatxaPopupReady='true';
  const frequencyKey='hatxa_newsletter_seen_v1';
  let shown=false;
  let elapsed=false;
  let lastSeen=0;
  const pageScroller=document.querySelector('.page-wrapper');
  try{lastSeen=Number(localStorage.getItem(frequencyKey)||0)}catch{}
  const remember=()=>{shown=true;try{localStorage.setItem(frequencyKey,String(Date.now()))}catch{}};
  const open=()=>{
    if(popup.open)return;
    if(document.querySelector('dialog[open]'))return;
    popup.showModal();remember();popup.querySelector('[data-hatxa-popup-title]')?.focus();
  };
  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    if(event.target.closest('[data-hatxa-open-newsletter]'))open();
    if(event.target.closest('[data-hatxa-close-popup]'))popup.close();
    if(event.target===popup){const box=popup.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)popup.close()}
  });
  if(popup.querySelector('[data-hatxa-popup-result]'))open();
  const check=()=>{
    if(!elapsed||shown||popup.dataset.automaticAllowed!=='true'||Date.now()-lastSeen<7*24*60*60*1000||document.visibilityState!=='visible')return;
    if(document.activeElement instanceof HTMLElement&&document.activeElement.matches('input,textarea,select'))return;
    const usePageScroller=pageScroller&&pageScroller.scrollHeight>pageScroller.clientHeight;
    const scrollable=usePageScroller?pageScroller.scrollHeight-pageScroller.clientHeight:document.documentElement.scrollHeight-window.innerHeight;
    const position=usePageScroller?pageScroller.scrollTop:window.scrollY;
    if(scrollable>0&&position/scrollable>=0.4)open();
  };
  window.addEventListener('scroll',check,{passive:true});
  pageScroller?.addEventListener('scroll',check,{passive:true});
  window.setTimeout(()=>{elapsed=true;check()},35000);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupHatxaPopup);else setupHatxaPopup();
document.addEventListener('shopify:section:load',setupHatxaPopup);
})();
